import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { RoboEvent } from '../../models/RoboCall/RoboEvent';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface RoboEventState {
  items: RoboEvent[];
  totalItemsCount: 0;
  status: Status;
}

const initialState: RoboEventState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export interface RoboEventResponse {
  items: RoboEvent[];
  totalItemsCount: 0;
}

export interface RoboEventRequest {
  selectedDate: string;
  Filter: string;
  PageIndex: number;
  PageSize: number;
}
export const getRoboEvents = createAsyncThunk(
  'roboEvent/event-robocallsurvey-list',
  async (request: RoboEventRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<RoboEventResponse>(
        'events/robocallsurvey',
        {
          params: {
            Filter: request.Filter,
            PageIndex: request.PageIndex,
            PageSize: request.PageSize,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список событий!');
    }
  },
);

export const roboEventSlice = createSlice({
  name: 'roboEvent',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRoboEvents.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getRoboEvents.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
        return state;
      })
      .addCase(getRoboEvents.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список событий';
        return state;
      });
  },
});

export default roboEventSlice.reducer;

export const selectRoboEvents = (state: RootState) => state.roboEvent.items;

export const roboStatus = (state: RootState) => state.roboEvent.status;

export const totalRoboEvents = (state: RootState) =>
  state.roboEvent.totalItemsCount;
